export default __webpack_public_path__ + "static/travel-booking-platform-integration-7faba73800ec64d63c6efb4cf558d0e9.jpg";